@if (initialized && model) {
  <div>
    @if (model.subscription && step === 'confirm') {
      <app-cancel-number-confirmation
        (back)="resetWorkflow()"
        [block]="model.block"
        [cancellationDate]="model.subscription?.nextPossibleDowngradeDate"
        (confirmed)="onCancellationConfirmed($event)">
      </app-cancel-number-confirmation>
    }
    @if (step === 'contact') {
      <app-select-invoice-contact
        [customer]="model.customer"
        [subscription]="model.subscription"
        (back)="onContactBack()"
        [historyBack]="false"
        (selected)="onContact($event)">
      </app-select-invoice-contact>
    }
    @if (step === 'address') {
      <app-invoice-address
        (next)="onInvoiceAddress($event)"
        (backEvent)="onInvoiceAddressBack()"
        [company]="model.company"
        [historyBack]="false">
      </app-invoice-address>
    }
    @if (isSepa && step === 'payment') {
      <app-payment-method
        (next)="onPaymentMethod($event)"
        [onlyEmit]="true"
        (backEvent)="onPaymentMethodBack()"
        [historyBack]="false"
        [paymentMethod]="paymentMethod">
      </app-payment-method>
    }
    @if (model.subscription && step === 'checkout-summary') {
      <app-checkout-one-summary
        backLabel="app_cancel"
        [historyBack]="false"
        [subscription]="model.subscription"
        (back)="onSummaryBack()"
        (buy)="onSummaryBuy()">
      </app-checkout-one-summary>
    }
    @if (step === 'complete') {
      <app-partner-upgrade-offer-sent
        (next)="onComplete()"
        [customerEmail]="model.saleOrder?.contact?.email">
      </app-partner-upgrade-offer-sent>
    }
  </div>
}